import useIR35FAQs from "@/hooks/useIR35FAQs";
// import { ServiceCard } from "@/ui/ServiceCard";
import cn from "classnames";
import { Container, Stack, Tabs, Tab } from "react-bootstrap";
import { Buttons } from "@/ui/Buttons";

import classes from "./styles.module.scss";

export default function ({
  className = "py-4 py-md-5",
  title,
  description,
  EditableText,
  EditableHtml,
  theme = "light",
  buttons,
  buttonsClassName = "mt-5",
}) {
  const faqs = useIR35FAQs();

  return (
    <div className={cn(className, classes.IR35FAQs)} data-bs-theme={theme}>
      <Container fluid="md" className="mw-xl text-center mb-5">
        <EditableText path="title" tag="h2">
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </EditableText>
        <EditableHtml path="description">
          <span dangerouslySetInnerHTML={{ __html: description }} />
        </EditableHtml>
      </Container>
      <Container>
        <Tabs defaultActiveKey={faqs[0]?.title || "General"} className="mb-4" id="faq-tabs">
          {faqs.map((post, index) => (
            <Tab key={index} eventKey={post.title || "General"} title={post.title || "General"}>
              <div className="py-3">
                <div dangerouslySetInnerHTML={{ __html: post.content }} />
              </div>
            </Tab>
          ))}
        </Tabs>
        <Buttons buttons={buttons} className={buttonsClassName} />
      </Container>
    </div>
  );
}
